import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthenticationInfoCard = () => {
  const features = [
    {
      icon: 'Shield',
      title: 'Secure Verification',
      description: 'OTP-based authentication ensures only authorized users can register teams',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'Users',
      title: '3 Teams Per Number',
      description: 'Register up to 3 cricket teams using a single mobile number (1 each in U14 Boys, U16 Boys, and U15 Girls)',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'Clock',
      title: 'Quick Access',
      description: 'Resume your registration anytime with the same mobile number',
      color: 'from-amber-500 to-amber-600'
    },
    {
      icon: 'Lock',
      title: 'Data Protection',
      description: 'Your information is encrypted and stored securely',
      color: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-xl p-8 lg:p-10 relative overflow-hidden">
      {/* Decorative gradient overlay */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-primary/5 to-transparent rounded-full blur-2xl"></div>
      
      <div className="relative z-10">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-14 h-14 bg-gradient-to-br from-primary to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
            <Icon name="Info" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Why Mobile Verification?</h3>
            <p className="text-sm text-gray-600 mt-1">Secure and convenient authentication</p>
          </div>
        </div>
        
        <div className="grid gap-6 mb-8">
          {features?.map((feature, index) => (
            <div key={index} className="flex gap-4 group">
              <div className={`w-12 h-12 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center flex-shrink-0 shadow-md group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={feature?.icon} size={20} color="#FFFFFF" />
              </div>
              <div className="flex-1 pt-1">
                <h4 className="text-base font-semibold text-gray-900 mb-1">{feature?.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Simplified info note */}
        <div className="pt-6 border-t border-gray-200">
          <div className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl border border-blue-100">
            <Icon name="MessageSquare" size={18} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs text-gray-700 leading-relaxed">
              <strong className="text-gray-900">SMS Notifications:</strong> You'll receive OTP and registration updates from <strong className="text-primary">LOOPEN</strong> short code. Please ensure your number can receive messages from this sender.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationInfoCard;